import React from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { KnowledgeBaseLink } from 'common/core/components/SupportLinks'
import { SupportedHelpArticleLanguage, useHelpArticleLink } from 'common/hooks/useHelpArticleLink'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const WaServiceMessagesChargeNotification = () => {
  const helpArticleLink = useHelpArticleLink(KnowledgeBaseLink.WA_PRICING, [
    SupportedHelpArticleLanguage.EN,
    SupportedHelpArticleLanguage.ES,
    SupportedHelpArticleLanguage.PT,
  ])

  const handleShowMore = () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.WA_SERVICE_MESSAGES_CHARGE.LEARN_MORE.CLICK')
  }

  return (
    <>
      <span data-test-id="wa-service-messages-charge-notification">
        {l.translate(
          `Starting October 1st, 2026, Meta will change how WhatsApp messages are charged.`,
        )}
      </span>
      <a
        target="_blank"
        rel="noreferrer"
        className={cx(cm.more, 'm-l-xs')}
        href={helpArticleLink}
        onClick={handleShowMore}
      >
        {l.translate('Learn more')}
      </a>
    </>
  )
}
